import React, { useEffect, useRef } from "react";


export default function Toggle(props) {
    const ref = useRef();

    useEffect(() => {
      ref.current.querySelectorAll('li').forEach(li => {
        li.addEventListener('click', () => {
          ref.current.querySelector('.selected').classList.remove('selected');
          li.classList.add('selected');
        });
      });
    });

    return <ul ref={ref} className="ds-toggle">{props.children}</ul>
}


/*

Usage:

<Toggle>
  <li>Label</li>
</Toggle>

*/